import React from 'react'

export const P = ({children, className, onClick}) => {
    return (
        <p className={className} onClick={onClick}>
            {children}
        </p>
    )
}
